import { DISCOUNT_ABUSE_BOOKING_REPORT, DOWNLOAD_DISCOUNT_ABUSE_BOOKING_REPORT } from 'actions/dataReport';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import Footer from 'components/general/Footer';
import ReactPagination from 'components/general/ReactPagination';
import AdminHeader from 'components/header';
import Button from 'components/inputs/Button';
import Card from 'components/inputs/Card';
import DateTimePicker from 'components/inputs/DateTimePicker';
import LayoutContainer from 'components/layout/LayoutContainer';
import fileDownload from 'js-file-download';
import * as _ from 'lodash';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsDownload } from 'react-icons/bs';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';

const DiscountAbuseReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(moment(new Date()).startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));

  const reportTableHeader = [
    {
      id: 'srNo',
      header: t('discountAbuseBookings.srNo'),
    },
    {
      id: 'bookingId',
      header: t('discountAbuseBookings.bookingId'),
    },
    {
      id: 'transactionID',
      header: t('discountAbuseBookings.transactionID'),
    },
    {
      id: 'userName',
      header: t('discountAbuseBookings.userName'),
    },
    {
      id: 'number',
      header: t('discountAbuseBookings.number'),
    },
    {
      id: 'station',
      header: t('discountAbuseBookings.station'),
    },
    {
      id: 'chargerId',
      header: t('discountAbuseBookings.chargerId'),
    },
    {
      id: 'vehicleModel',
      header: t('discountAbuseBookings.vehicleModel'),
    },
    {
      id: 'usedEvccId',
      header: t('discountAbuseBookings.usedEvccId'),
    },
    {
      id: 'actualEvccId',
      header: t('discountAbuseBookings.actualEvccId'),
    },
    {
      id: 'totalAmount',
      header: t('discountAbuseBookings.totalAmount'),
    },
    {
      id: 'pricePerUnit',
      header: t('discountAbuseBookings.pricePerUnit'),
    },
    {
      id: 'discount',
      header: t('discountAbuseBookings.discount'),
    },
    {
      id: 'timeStamp',
      header: t('discountAbuseBookings.timeStamp'),
    },
  ];

  const {
    discountAbuseBookings: discountAbuseBookingReportList,
    isLoading: isLoader,
    page,
    total: totalData,
    limit,
    totalPages,
  } = useSelector((state) => state.discountAbuseBookingReport);

  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
  const profileData = useSelector((state) => state.profile.userProfile);
  const currentUserName = _.get(profileData, 'name', '');

  const discountAbuseBookingsReport = useCallback(
    (value) => {
      const data = {
        ...value,
        from: moment(startDate).toISOString(),
        to: moment(endDate).toISOString(),
      };
      dispatch({
        type: DISCOUNT_ABUSE_BOOKING_REPORT.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            // onCloseAdvanceFilterPopup();
          }
        },
      });
    },
    [startDate, endDate]
  );

  const downloadDiscountAbuseBookingReport = useCallback(() => {
    const data = {
      excel: true,
      from: moment(startDate).toISOString(),
      to: moment(endDate).toISOString(),
    };

    dispatch({
      type: DOWNLOAD_DISCOUNT_ABUSE_BOOKING_REPORT.REQUEST,
      payload: data,
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            fileDownload(res.data, `${'Discount Abuse Booking Report'}.xlsx`);
          }
        }
      },
    });
  }, [startDate, endDate]);

  const dateFilter = useCallback(() => {
    const filterDateData = {
      from: moment(startDate).utc(),
      to: moment(endDate).utc(),
    };
    discountAbuseBookingsReport(filterDateData);
  }, [startDate, endDate]);

  const handlePageClick = useCallback(
    (page) => {
      if (startDate && endDate) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          page: page.selected + 1,
        };
        discountAbuseBookingsReport(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        discountAbuseBookingsReport(data);
      }
    },
    [startDate, endDate]
  );

  const downloadFile = () => {
    downloadDiscountAbuseBookingReport();
  };

  const TableLoader = () => {
    return <Skeleton height={15} width={100} />;
  };

  const TableHeader = () => {
    return (
      <thead>
        <tr>
          {reportTableHeader.map((item) => {
            return (
              <th key={item.id}>
                <div>
                  <span>{isLoader ? <TableLoader /> : item.header}</span>
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  const TableBody = () => {
    return (
      <tbody>
        {isLoader ? (
          <tr>
            <td colSpan={reportTableHeader.length} className="border-0">
              <div className="loader--block">
                <TableLoader />
              </div>
            </td>
          </tr>
        ) : _.isEmpty(discountAbuseBookingReportList) ? (
          <tr>
            <td colSpan={14} className="border-0">
              <div className="empty-data-block">No Discount Abuse Bookings Found</div>
            </td>
          </tr>
        ) : (
          !(isLoader || _.isUndefined(isLoader)) &&
          _.map(discountAbuseBookingReportList, (item, key) => {
            const serial_num = limit * (page - 1) + key;
            return (
              <tr key={item.transaction_id}>
                <td>{isLoader ? <TableLoader /> : serial_num + 1}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'booking_id', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'transaction_id', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'user_name', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'phone', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'station', '-')}</td>
                <td>{isLoader ? <TableLoader /> : `${_.get(item, 'chargerId', '-')} (${_.get(item, 'gun_name', '-')})`}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'vehicle_model', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'used_evcc_id', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'actual_evcc_id', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'total_amount', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'price_per_unit', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'discount', '-')}</td>
                <td>
                  {isLoader ? (
                    <TableLoader />
                  ) : (
                    (moment
                      .utc(_.get(item, 'timeStamp', '-'))
                      .tz('Asia/Kolkata')
                      .format() ?? '-')
                  )}
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    );
  };

  const ReportHeader = () => {
    return (
      <div className="data-report__box">
        <Row className="data-report__row">
          <Col xl={'auto'} md={'auto'}>
            <div style={{ display: 'flex', marginTop: '0.7rem', fontWeight: 'bold' }}>{t('discountAbuseBookings.title')}</div>
          </Col>
          <Col xl={'auto'} md={'auto'}>
            <div className="data-report-date_picker">
              <DateTimePicker
                onChangeOfStartDate={(item) => setStartDate(item)}
                onChangeOfEndDate={(item) => setEndDate(item)}
                initialValueOfStartDate={startDate}
                initialValueOfEndDate={endDate}
              />
            </div>
          </Col>
          <Col xl={'auto'} md={'auto'}>
            <div className="report-search-box" onClick={dateFilter}>
              <Button className="report-search-button">Search</Button>
            </div>
          </Col>

          <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
            {isLoading ? (
              <div className="loader--block">
                <Spinner as="span" animation="border" size="sm" role="status" />
              </div>
            ) : (
              <div className="report-excel-icon">
                <BsDownload title="Download" size={28} color={'#3c7cdd'} />
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  const ReportTable = () => {
    return (
      <div className="data-report__table">
        <div className="table-responsive">
          <table className="record-list-table" id="table-to-xls">
            <TableHeader />
            <TableBody />
          </table>
        </div>
      </div>
    );
  };

  useEffect(() => {
    discountAbuseBookingsReport();
  }, []);

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.discountAbuseBookings')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="data-report--main">
              <Card>
                <div className="data-report__inner">
                  <ReportHeader />
                  <ReportTable />
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(discountAbuseBookingReportList) && (
                    <ReactPagination
                      currentPage={page}
                      limit={limit}
                      total={totalData}
                      handlePageClick={(pageVal) => handlePageClick(pageVal)}
                      totalPages={totalPages}
                      marginPagesDisplayed={1}
                    />
                  )}
                </div>
              </Card>
            </div>
          </div>
        </SkeletonTheme>
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>
    </>
  );
};

export default DiscountAbuseReport;
